export default "__VITE_ASSET__CRYOxCfx__"